import { createResolver, } from '@spotify-internal/remote-config-core';
import { transportProvider } from '@spotify-internal/remote-config-provider-transport';
import { propertiesMiddleware } from '@spotify-internal/remote-config-middleware-properties';
import { cachingMiddleware } from '@spotify-internal/remote-config-middleware-caching';
import { backgroundFetchMiddleware } from '@spotify-internal/remote-config-middleware-background-fetch';
import { exposureMiddleware } from '@spotify-internal/remote-config-middleware-exposure';
import { installationIdMiddleware } from '@spotify-internal/remote-config-middleware-installationid';
import { sessionConfigMiddleware } from '@spotify-internal/remote-config-middleware-session-config';
export const BrowserResolver = createResolver(transportProvider)
    .addMiddleware(propertiesMiddleware)
    .addMiddleware(cachingMiddleware)
    .addMiddleware(backgroundFetchMiddleware)
    .addMiddleware(exposureMiddleware)
    .addMiddleware(installationIdMiddleware)
    .addMiddleware(sessionConfigMiddleware);
//# sourceMappingURL=browser.js.map